import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";
import { AGENT_NAME } from "../lib/site";

const VALUES = [["Plain English", "No jargon, no pressure."], ["Nationwide", "Help wherever you live."], ["One agent", "Same person, every year."]];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);
  return (
    <section id="about" ref={ref} data-testid="about-section" className="bg-[#F4F1EA] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative max-w-[400px] mx-auto lg:mx-0">
            <div className="arch overflow-hidden aspect-[1/1] bg-[#0B281E]">
              <motion.img style={{ y }} src="/img/jean.png" alt="Jean Max Andre, licensed life and health agent" className="w-full h-[110%] object-cover object-[center_30%] -mt-[5%]" data-testid="about-agent-image" />
            </div>
            <div className="absolute -bottom-6 -right-2 sm:-right-8 bg-[#0B281E] text-[#FAF8F5] rounded-2xl px-6 py-5">
              <p className="font-serif-d text-2xl">{AGENT_NAME}</p>
              <p className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[#E5A855] mt-1">Licensed Life &amp; Health Agent</p>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>03 — Your agent</Eyebrow>
            <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-[#0B281E] mt-5 leading-[1.02]">An anchor, not a call center.</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base md:text-lg text-[#52635B] leading-relaxed max-w-2xl">
              Hi, I'm {AGENT_NAME}. I started Anchorwell so families, self-employed professionals and retirees could get honest guidance from a real person who answers the phone. Whether you need a marketplace plan this month or a lifelong strategy for your family's future, I'll lay out every option clearly and let you decide.
            </p>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-3 gap-6">
            {VALUES.map(([t, d], i) => (
              <Reveal key={t} delay={0.15 + i * 0.08}>
                <div className="border-t-2 border-[#C88A35] pt-5" data-testid={`about-value-${i}`}>
                  <p className="font-serif-d text-2xl text-[#0B281E]">{t}</p>
                  <p className="text-sm text-[#52635B] mt-1">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
